import { render, staticRenderFns } from "./CPFDialog.vue?vue&type=template&id=959652d2"
import script from "./CPFDialog.vue?vue&type=script&lang=js"
export * from "./CPFDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports